export const CrisisSection = () => (
  <section id="crisis" className="recruit-problem">
    <div className="recruit-shell recruit-split-heading">
      <div>
        <p className="recruit-eyebrow">The person behind the application</p>
        <h2>
          A polished resume
          <br />
          still leaves questions.
        </h2>
      </div>
      <p>
        What did they actually work on? How do they explain their choices? Where should you dig
        deeper? Bring the resume, their introduction, and interview responses into the same review.
      </p>
    </div>
  </section>
);
